import { httpClient, httpClient1, handleError } from '@/api/index'

export const _getEatereyUserTimes = ({ date_range, eatery_id, api_key }) => {
  return httpClient.post(`day/times/query`, { date_range, eatery_id }, {
    headers: {
      'api-key': api_key
    }
  }).then(res => {
    return Promise.resolve(res.data)
  }).catch(handleError)
}
export const _getBindUsers = ({ date_range, eatery_id, api_key }) => {
  return httpClient1.post(`day/bind_times/query`, {
    date_range,
    eatery_id
  }, {
    headers: {
      'api-key': api_key

    }
  }).then(res => res.data).catch(handleError)
}
